import React, { useState, useLayoutEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from './Layouts/Header';
import Footer from './Layouts/Footer';
import { loginUser } from '../utils/apiService';
const Login = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');


    useLayoutEffect(() => {
        const timer = setTimeout(() => {
            if (window.animationText) window.animationText();
            if (window.scrollingEffect) window.scrollingEffect();
            if (window.animateImgItem) window.animateImgItem();

            if (window.ScrollTrigger) {
                window.ScrollTrigger.refresh();
            }
        }, 100);

        return () => {
            clearTimeout(timer);
            if (window.revertAnimations) window.revertAnimations();
            if (window.revertHeadline) window.revertHeadline();
        };
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear error for this field when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
          if (errors.submit) {
            setErrors(prev => ({
                ...prev,
                submit: ''
            }));
        }
    };

    const togglePassword = () => {
        setShowPassword(!showPassword);
    };

    const validateForm = () => {
        const newErrors = {};

        // Email validation
        if (!formData.email) {
            newErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = 'Email is invalid';
        }

        // Password validation
        if (!formData.password) {
            newErrors.password = 'Password is required';
        } else if (formData.password.length < 6) {
            newErrors.password = 'Password must be at least 6 characters';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setIsSubmitting(true);
            setErrors({});
        setSuccessMessage('');
         try {
            const response = await loginUser({
                email: formData.email,
                password: formData.password
            });

            if (response.status) {
                // Login successful
                setSuccessMessage(response.message || 'Login successful!');
                
                // Store token and user data
                if (response.token) {
                    localStorage.setItem('token', response.token);
                }
                if (response.user) {
                    localStorage.setItem('user', JSON.stringify(response.user));
                }
                
                // Redirect after a short delay
                setTimeout(() => {
                    navigate('/dashboard'); // Update this to your desired route
                }, 1500);
            } else {
                // Login failed
                if (response.errors && Object.keys(response.errors).length > 0) {
                    // Set field-specific errors
                    setErrors(response.errors);
                } else {
                    // Set general error message
                    setErrors({
                        submit: response.message || 'Login failed. Please check your credentials.'
                    });
                }
            }
        } catch (error) {
            console.error('Login error:', error);
            setErrors({
                submit: 'An unexpected error occurred. Please try again later.'
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="wrapper position-relative">
            <Header />

            {/* Background Masks */}
            <div className="wrapper position-relative overflow-x-clip">
                <div className="mask mask-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="800" height="800" fill="none">
                        <circle cx="400" cy="400" r="325" stroke="url(#a6)" strokeWidth="150" />
                        <defs>
                            <linearGradient id="a6" x1="176" x2="569" y1="70.5" y2="674">
                                <stop offset="0" stopColor="#fff" stopOpacity="0.05" />
                                <stop offset="1" stopColor="#fff" stopOpacity="0" />
                            </linearGradient>
                        </defs>
                    </svg>
                </div>
                <div className="mask mask-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="800" height="800" fill="none">
                        <circle cx="400" cy="400" r="325" stroke="url(#e7)" strokeWidth="150" />
                        <defs>
                            <linearGradient id="e7" x1="176" x2="569" y1="70.5" y2="674">
                                <stop offset="0" stopColor="#fff" stopOpacity="0.05" />
                                <stop offset="1" stopColor="#fff" stopOpacity="0" />
                            </linearGradient>
                        </defs>
                    </svg>
                </div>
            </div>

            {/* Page Title */}
            <div className="page-title">
                <div className="tf-container">
                    <div className="page-title-content text-center">
                        <h1 className="title">
                            <span className="split-text effect-right">Login</span>
                        </h1>
                        <div className="breadkcum">
                            <Link to="/" className="link-breadkcum body-2 fw-7">
                                <span className="split-text effect-right">Home</span>
                            </Link>
                            <span className="dot"></span>
                            <span className="page-breadkcum body-2 fw-7">
                                <span className="split-text effect-right">Login</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="main-content">
                <section className="section-contact p-contact tf-spacing-2">
                    <div className="tf-container">
                        <div className="row justify-content-md-center">
                            <div className="col-lg-6">
                                <div className="section-contact-inner flex justify-content-between flex-wrap login-form">
                                    <form 
                                        id="loginform" 
                                        className="form-contact-us style-bg-dark-2 px-md-15" 
                                        onSubmit={handleSubmit}
                                    >
                                        {successMessage && (
                                            <div className="alert alert-success mb-37" role="alert">
                                                {successMessage}
                                            </div>
                                        )}
                                        <div className="cols mb-37 g-30">
                                            <fieldset className="item">
                                                <fieldset className="position-relative">
                                                    <i className="icon-email"></i>
                                                    <input 
                                                        type="email" 
                                                        name="email" 
                                                        id="email" 
                                                        placeholder="Email Address"
                                                        value={formData.email}
                                                        onChange={handleChange}
                                                        className={errors.email ? 'error' : ''}
                                                        disabled={isSubmitting}
                                                    />
                                                    {errors.email && (
                                                        <span className="error-message text-danger small d-block mt-1">
                                                            {errors.email}
                                                        </span>
                                                    )}
                                                </fieldset>
                                            </fieldset>
                                        </div>

                                       
                                        <div className="cols mb-37 g-30">
                                            <fieldset className="item">
                                                <fieldset className="position-relative">
                                                    <input 
                                                        type={showPassword ? "text" : "password"}
                                                        name="password" 
                                                        id="password" 
                                                        placeholder="Password"
                                                        value={formData.password}
                                                        onChange={handleChange}
                                                        className={errors.password ? 'error' : ''}
                                                        disabled={isSubmitting}
                                                    />
                                                    <i 
                                                        className={`toggle-password fa-regular ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}
                                                        onClick={togglePassword}
                                                        style={{ cursor: 'pointer' }}
                                                    ></i>
                                                    {errors.password && (
                                                        <span className="error-message text-danger small d-block mt-1">
                                                            {errors.password}
                                                        </span>
                                                    )}
                                                </fieldset>
                                            </fieldset>
                                        </div>

                                        {errors.submit && (
                                            <div className="alert alert-danger mb-37" role="alert">
                                                {errors.submit}
                                            </div>
                                        )}

                                        <div className="row">
                                            {/* <div className="col-lg-6 col-md-6 col-sm-12">
                                                <div className="mb-37">
                                                    <Link to="/forgot-password">Forgot Password</Link>
                                                </div>
                                            </div> */}
                                            <div className="col-lg-6 col-md-6 col-sm-12">
                                                <div className="mb-37 create-account">
                                                    <Link to="/register">Create an Account</Link>
                                                </div>
                                            </div>
                                        </div>
                                        <button 
                                            type="submit"
                                            className="tf-btn style-bg-primary w-full justify-content-center"
                                            disabled={isSubmitting}
                                        >
                                            <span>{isSubmitting ? 'Logging in....' : 'Submit'}</span>
                                            <i className="icon-arrow-right"></i>
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <Footer />
        </div>
    );
};

export default Login;